/**
 * Monta un modal directamente en `<body>`.
 *
 * Un velo `position: fixed` dibujado dentro de la página deja de cubrir la
 * pantalla en cuanto algún contenedor de arriba lleva un `transform` (las
 * animaciones de entrada lo llevan): pasa a medirse contra ese contenedor, se
 * queda tan alto como la página y el modal sale centrado a media página, sin
 * forma de llegar a su botón. Fuera de la página eso no puede pasar.
 */
import type { ReactNode } from 'react'
import { createPortal } from 'react-dom'

export function ModalPortal({ children }: { children: ReactNode }) {
  if (typeof document === 'undefined') return <>{children}</>
  return createPortal(children, document.body)
}
